export function validateStringIntent(str) {
    //
    // Regular expression pattern to match any whitespace character
    const prefixPattern = /^(?!sys)(?!\S*\s)\S+$/;

    // Check if the string contains any whitespace characters
    if (!prefixPattern.test(str) || str === '' || str.includes('#')) {
        return false; // String contains spaces
    }

    return true;
}

export function checkEmptyString(str) {
    // Check if the string contains only whitespaces
    if (str?.trim() === '') {
        return false; // String contains only whitespaces no characters
    }

    return true;
}

export function convertObjectToString(myObject) {
    var json = JSON.stringify(myObject); // {"type":"Fiat","model":"500","color":"White"}
    var unquoted = json.replace(/"([^"]+)":/g, '$1:');
    var result = unquoted.replaceAll('"', "'");
    return result;
}

export function convertToTitleCase(inputString) {
    if (!inputString) return '';

    const words = inputString.split('_');
    const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
    const resultString = capitalizedWords.join(' ');

    return resultString;
}

export function convertToUnderScor(inputString) {
    if (!inputString) return '';

    const words = inputString.trim()?.split(' ');
    const capitalizedWords = words.map(word => word.charAt(0).toLowerCase() + word.slice(1));
    const resultString = capitalizedWords.join('_');

    return resultString;
}

export function convertStringToObject(str) {
    // Remove single quotes around 'null' if present
    const cleanedStr = str.replace(/'null'/g, 'null');

    try {
        // Parse the cleaned string into a JavaScript object
        const obj = JSON.parse(cleanedStr);
        return obj;
    } catch (error) {
        console.error('Error parsing string to object:', error);
        return null;
    }
}

export function checkNameLengthWithSuffix(name, maxBytes = 38, suffix = '-Main') {
    // Append the suffix to the name
    const fullName = name + suffix;

    // Use TextEncoder to calculate the byte length
    const encoder = new TextEncoder();
    const byteLength = encoder.encode(fullName).length;

    // Check if the byte length exceeds the maxBytes limit
    if (byteLength > maxBytes) {
        return true;
    } else {
        return false;
    }
}
